import { store } from "@/store";
import { App } from "vue";
import { CountriesActionTypes } from "@/core/enum/Countries/Actions";

class Countries{

    public static vueInstance: App;

    public static init(app: App<Element>) {
        Countries.vueInstance = app;
    }

    public static async getCountries(payload={}) {
        return await store
        .dispatch(CountriesActionTypes.GET_COUNTRIES,payload)
    }

    public static async getCountryCode() {
        return await store
        .dispatch(CountriesActionTypes.GET_COUNTRY_CODE)
    }

    public static getCompanyInfo() {
        store
        .dispatch(CountriesActionTypes.GET_COMPANY_INFO)
    }
}

export default Countries;